<template>
  <section>
    <b-modal
      v-model="modal"
      size="lg"
      modal-class="border-0"
      header-class="background-primary"
      footer-class="justify-content-center"
      v-bind:centered="true"
      v-bind:hide-footer="true"
    >
      <template slot="modal-header">
        <h4
          class="container text-uppercase text-white font-weight-bold text-center mb-0"
        >
          Peraturan Forum
        </h4>
      </template>
      <div class="container px-5 py-2">
        <a href="#"
          ><img
            src="/static/images/page/about/posterForum.JPG"
            alt="posterForum"
            border="0"
            width="100%"
        /></a>
        <!--<a href="#"><img src="https://i.ibb.co/gj8hmz3/posterTO.jpg" alt="posterTO" border="0" width ="100%"></a>-->
        <button
          v-on:click="modal = false"
          class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto"
        >
          Kembali
        </button>
      </div>
    </b-modal>
    <div class="row justify-content-center">
      <div class="col col-lg-10 px-5">
        <nav aria-label="breadcrumb">
          <ul class="breadcrumb mt-5 mb-0 py-0">
            <li
              class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase"
              aria-current="page"
            >
              Forum
            </li>
          </ul>
          <ul class="breadcrumb forum py-0">
            <li class="breadcrumb-item font-weight-medium">
              <router-link v-bind:to="{ name: 'index' }"> Home </router-link>
            </li>
            <li class="breadcrumb-item font-weight-medium">
              <router-link v-bind:to="{ name: 'forum/index' }">
                Forum
              </router-link>
            </li>
            <li class="breadcrumb-item font-weight-medium">
              <router-link
                v-bind:to="{
                  name: 'forum/subject',
                  params: { id: category.gradeSubject.gradeID },
                }"
              >
                {{ category.gradeSubject.grade.name }}
              </router-link>
            </li>
            <li class="breadcrumb-item font-weight-medium">
              <router-link
                v-bind:to="{
                  name: 'forum/category',
                  params: { id: category.gradeSubjectID },
                }"
              >
                {{ category.gradeSubject.subject.name }}
              </router-link>
            </li>
            <li
              class="breadcrumb-item font-weight-medium active"
              aria-current="page"
            >
              {{ category.title }}
            </li>
          </ul>
        </nav>
        <div class="row">
          <div class="col">
            <div class="card shadow-sm mb-3 border-0">
              <div class="card-body">
                <h3 class="text-danger font-weight-bold">
                  {{ category.title }}
                </h3>
                <div v-html="category.description"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3" id="primary-form">
          <div class="col">
            <form v-on:submit.prevent="paginate(1, false)">
              <div class="row">
                <div class="col-xl-3 col-lg">
                  <label class="text-muted d-lg-flex d-none">Urutkan</label>
                  <select v-model="sort" class="form-control form-control-sm">
                    <option
                      v-for="sortAttribute in sorts"
                      v-bind:value="sortAttribute"
                      v-bind:key="sortAttribute.name"
                    >
                      {{ sortAttribute.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg">
                  <label class="text-muted d-lg-flex d-none">Search</label>
                  <input
                    v-model="form.keyword"
                    type="search"
                    class="form-control form-control-sm"
                    placeholder="Search..."
                  />
                </div>
                <div class="col-auto align-self-end">
                  <button type="submit" class="btn btn-danger btn-sm px-4">
                    Search
                  </button>
                </div>
                <div
                  class="col-auto align-self-end ml-auto"
                  v-if="roleElligible()"
                >
                  <router-link
                    v-bind:to="{
                      name: 'forum/thread/add',
                      params: { id: category.id },
                    }"
                    class="btn btn-danger btn-sm px-4"
                  >
                    Create Thread
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card shadow-sm mb-3 border-0">
              <div class="card-body py-2">
                <div class="row justify-content-end">
                  <div class="col align-self-center">
                    Halaman {{ page }} dari {{ pageCount }}
                  </div>
                  <div class="col-auto ml-auto">
                    <paginate
                      v-model="page"
                      next-text="<i class='fa fa-chevron-right'></i>"
                      prev-text="<i class='fa fa-chevron-left'></i>"
                      v-bind:click-handler="paginate"
                      v-bind:page-count="pageCount"
                      container-class="pagination pagination-sm flex-wrap mb-0"
                      page-class="page-item"
                      prev-class="page-item"
                      v-bind:next-class="'page-item'"
                      page-link-class="page-link"
                      prev-link-class="page-link"
                      next-link-class="page-link"
                      v-bind:hide-prev-next="true"
                    >
                    </paginate>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="threads.length">
          <div class="row" v-for="thread in threads">
            <div class="col">
              <div class="card shadow-sm mb-3 border-0">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <h4 class="font-weight-medium">
                        {{ thread.user.name }}
                        <small class="text-muted">{{
                          listRoles(thread.user)
                        }}</small>
                      </h4>
                    </div>
                    <div class="col-auto ml-auto">
                      <h5 class="text-muted">
                        Dibuat Tanggal:
                        {{
                          [thread.createdAt, "YYYY-MM-DD HH:mm:ss"]
                            | moment("D MMMM YYYY - HH:mm")
                        }}
                      </h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mb-2">
                      <router-link
                        v-bind:to="{
                          name: 'forum/thread/view',
                          params: { id: thread.id },
                        }"
                        class="h3 font-weight-bold"
                      >
                        {{ thread.title }}
                      </router-link>
                      <i
                        v-if="thread.isSolved"
                        class="fa fa-check-circle text-success"
                        v-b-tooltip.hover
                        title="Solved"
                      ></i>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-auto">
                      <h4 class="font-weight-medium text-muted mb-0">
                        Balasan: {{ thread.commentsCount }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div class="col">
              <div class="card shadow-sm mb-3 border-0">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <h4 class="font-weight-medium mb-0 text-center">
                        Pencarian tidak ditemukan
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="row">
          <div class="col">
            <div class="card shadow-sm mb-3 border-0">
              <div class="card-body py-2">
                <div class="row justify-content-end">
                  <div class="col align-self-center">
                    Halaman {{ page }} dari {{ pageCount }}
                  </div>
                  <div class="col-auto ml-auto">
                    <paginate
                      v-model="page"
                      next-text="<i class='fa fa-chevron-right'></i>"
                      prev-text="<i class='fa fa-chevron-left'></i>"
                      v-bind:click-handler="paginate"
                      v-bind:page-count="pageCount"
                      container-class="pagination pagination-sm flex-wrap mb-0"
                      page-class="page-item"
                      prev-class="page-item"
                      v-bind:next-class="'page-item'"
                      page-link-class="page-link"
                      prev-link-class="page-link"
                      next-link-class="page-link"
                      v-bind:hide-prev-next="true"
                    >
                    </paginate>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { employeeRoles, additionalRoles } from "@/params.js";
import Paginate from "vuejs-paginate";

export default {
  name: "ForumThreadIndex",
  computed: mapState(["profile"]),
  components: {
    Paginate,
  },
  data() {
    return {
      form: {
        keyword: "",
      },
      category: { gradeSubject: { grade: {}, subject: {} } },
      threads: [],
      sort: {},
      modal: true,
      sorts: [
        { sortColumn: "id", sortType: "desc", name: "Terbaru" },
        { sortColumn: "comments", sortType: "desc", name: "Populer" },
        { sortColumn: "title", sortType: "asc", name: "Alfabet" },
      ],
      roles: [],
      page: 1,
      pageCount: 20,
    };
  },
  methods: {
    paginate(page, scroll = true) {
      this.axios
        .get(process.env.API_URL + "/thread", {
          params: Object.assign({}, this.form, this.sort, {
            page: page,
            forumSubcategoryID: this.category.id,
          }),
        })
        .then((response) => {
          this.threads = response.data.data.data;
          this.pageCount = response.data.data.total
            ? response.data.data.last_page
            : 0;

          if (scroll) {
            document.getElementById("primary-form").scrollIntoView();
            var headerElement = document.getElementsByTagName("nav");
            if (headerElement.length) {
              window.scrollBy(0, headerElement[0].offsetHeight * -1);
            }
          }
        });
    },
    listRelations(relations) {
      return typeof relations !== typeof undefined
        ? relations.map((object) => object.name).join(", ")
        : "";
    },
    listRoles(user) {
      var roles = [];
      for (var i in additionalRoles) {
        if (user["is" + additionalRoles[i].id]) {
          roles.push(additionalRoles[i].id);
        }
      }
      if (user.isEmployee) {
        for (var i in employeeRoles) {
          if (user.employee["is" + employeeRoles[i].id]) {
            roles.push(employeeRoles[i].id);
          }
        }
      }
      return this.listRelations(
        this.roles.filter((object) => roles.includes(object.id))
      );
    },
    roleElligible() {
      return (
        this.profile.isAdmin ||
        (this.profile.isStudent &&
          this.profile.student.remainingVouchers > 0) ||
        (this.profile.isEmployee &&
          (this.profile.employee.isDirector || this.profile.employee.isManager))
      );
    },
  },
  created() {
    this.sort = this.sorts.length ? this.sorts[0] : {};
    this.roles = employeeRoles.concat(additionalRoles);

    this.axios
      .get(process.env.API_URL + "/forum-subcategory/" + this.$route.params.id)
      .then((response) => {
        this.category = response.data.data;

        this.paginate(1);

        document.title =
          "Forum - " +
          this.category.gradeSubject.grade.name +
          " " +
          this.category.gradeSubject.subject.name +
          " " +
          this.category.title +
          " | " +
          process.env.APP_NAME;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forum/thread/Index.vue